import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";
import {Website} from "../../../website";


@Component({
    selector: 'db-ecommerce-payment-method-action',
    templateUrl: './payment-method-action.component.html',
    styleUrls: ['./payment-method-action.component.scss'],
    standalone: false
})
export class EcommercePaymentMethodActionComponent implements OnInit {

  @Input() elementId: string;
  @Input() title: string;
  @Input() enabled: boolean;
  @Input() needSetup: boolean;
  @Input() website: Website;
  @Output() switchStatus = new EventEmitter<boolean>();
  public loading: boolean;

  constructor() {
  }

  ngOnInit() {
  }

  public changeStatus(): void {
    this.enabled = !this.enabled;
    this.switchStatus.emit(this.enabled);
  }

}
